"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagNameInputController = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const modal_service_1 = require("../../components/modal/modal.service");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
const tag_name_input_confirmation_1 = require("./tag.name.input.confirmation");
class TagNameInputController {
    constructor(tagState, tag) {
        this.tagState = tagState;
        this.editState = tagState.edit;
        this.tag = tag;
    }
    getInputState() {
        return this.editState.input;
    }
    getInputValue() {
        return this.editState.input.value;
    }
    getTagFilterValue() {
        return services_1.Services.Search.filterState.filter;
    }
    zoomToTag() {
        this.tagState.map.zoomToTag(this.tag.objectId);
        if (page_state_1.CurrentState.expandedTagId === this.tag.objectId) {
            this.tagState.collapseTag(this.tag);
        }
        else {
            this.tagState.expandTag(this.tag);
        }
    }
    updateEdit(value) {
        this.editState.input.setTouched();
        this.editState.input.setValue(value);
    }
    acceptEdit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const name = this.editState.input.value;
            if (name == null) {
                this.cancelEdit();
                return Promise.resolve();
            }
            const cleanName = name.trim();
            if (cleanName.length === 0 || cleanName === this.tag.name) {
                this.cancelEdit();
                return Promise.resolve();
            }
            const tagSummary = store_1.AppStore.TagSummary.get(this.tag.objectId);
            if (tagSummary == null) {
                services_1.Logger.error(`Cannot rename tag '${this.tag.name}' before tag summary retrieved.`);
                return Promise.resolve();
            }
            // Make sure this tag is not selected if we are renaming it.
            page_state_1.CurrentState.Tag.selectTag(this.tag.objectId, false);
            const isMerge = this.tagState.tags.some(t => t.name === name);
            const modelResponse = yield this.showRenameModal(isMerge, tagSummary.revisions.length, name);
            this.cancelEdit();
            if (modelResponse.cancel) {
                return;
            }
            this.editState.setRenaming(this.tag.objectId);
            if (isMerge) {
                const collections = yield this.getCollections(tagSummary);
                yield services_1.Services.Collection.move(collections, name);
            }
            else {
                yield services_1.Services.Tag.rename(this.tag.objectId, name);
                // this.tag is now outdated, we need to reassign it to the updated tag
                const updatedTag = store_1.AppStore.Tag.get(this.tag.objectId);
                if (updatedTag && updatedTag !== this.tag) {
                    this.tag = updatedTag;
                }
            }
            page_state_1.CurrentState.clearSelected();
            this.editState.cancelRenaming();
        });
    }
    cancelEdit() {
        this.editState.setTagId(null);
        this.editState.input.reset();
        if (this._tagCard) {
            services_1.Services.FocusAway.dropByElement(this._tagCard);
        }
    }
    get autoCompleteOptions() {
        return this.tagState.tags
            .filter(tag => tag.objectId !== this.tag.objectId)
            .map(tag => ({ id: tag.objectId, value: tag.name }));
    }
    set tagCard(tagCard) {
        this._tagCard = tagCard;
    }
    showRenameModal(merge, collectionCount, newName) {
        if (merge) {
            return modal_service_1.ModalService.open({
                title: (0, i18n_1.Translate)(i18n_1.T.TAG_MERGE_TITLE),
                content: tag_name_input_confirmation_1.TagNameInputConfirmationContent.view(collectionCount, this.tag.name, newName),
                hasCancel: TagNameInputController.CAN_CANCEL_RENAME
            });
        }
        return Promise.resolve({ ok: true, cancel: false });
    }
    getCollections(tagSummary) {
        const collections = [];
        for (const revision of tagSummary.revisions) {
            const collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
            if (collectionSummary != null) {
                collections.push(Promise.resolve(collectionSummary));
            }
            else {
                collections.push(store_1.AppStore.CollectionSummary.fetch(revision));
            }
        }
        return Promise.all(collections);
    }
}
exports.TagNameInputController = TagNameInputController;
TagNameInputController.CAN_CANCEL_RENAME = true;
tslib_1.__decorate([
    mobx_1.action
], TagNameInputController.prototype, "updateEdit", null);
tslib_1.__decorate([
    mobx_1.action
], TagNameInputController.prototype, "cancelEdit", null);
tslib_1.__decorate([
    mobx_1.computed
], TagNameInputController.prototype, "autoCompleteOptions", null);
//# sourceMappingURL=tag.name.input.ctrl.js.map